import { a11yProps, sizeTab, ROUTER_PATHS } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TabOrdenTrabajoNocPendiente from "../../components/TabOrdenTrabajoNocPendiente";
import TabOrdenTrabajoNocRealizadas from "../../components/TabOrdenTrabajoNocRealizadas";
import TabOrdenTrabajoNocFinalizadas from "../../components/TabOrdenTrabajoNocFinalizadas";

export default function OrdenesTrabajoNocPage() {

    const returnUrlOrdenTrabajoPage = ROUTER_PATHS.noc.ordenesDeTrabajoNocNav;
    const [valueTab, setValueTab] = useState(0);

    return (
        <>
            <SingleTableBoxScene
                py={2}
                title={"Ordenes de Trabajo NOC"}
                textRedirect={"Crear Nueva Orden"}
                urlRedirect={`${returnUrlOrdenTrabajoPage}/crear`}
                visibleReport={true}
            >
                <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
                    <Tabs
                        value={valueTab}
                        onChange={(_event: React.SyntheticEvent, newValue: number) => {
                            setValueTab(newValue);
                        }}
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        aria-label="scrollable force tabs ordenes trabajo noc"
                    >
                        <Tab label={'Pendientes'} {...a11yProps(0)} />
                        <Tab label={'Realizadas'} {...a11yProps(1)} />
                        <Tab label={'Finalizadas'} {...a11yProps(2)} />
                    </Tabs>
                </Box>

                <CustomTabPanel value={valueTab} index={0}>
                    <TabOrdenTrabajoNocPendiente />
                </CustomTabPanel>
                <CustomTabPanel value={valueTab} index={1}>
                    <TabOrdenTrabajoNocRealizadas />
                </CustomTabPanel>
                <CustomTabPanel value={valueTab} index={2}>
                    <TabOrdenTrabajoNocFinalizadas />
                </CustomTabPanel>
            </SingleTableBoxScene>
        </>
    );

}